import {z} from '@hono/zod-openapi';

export const mobileDeRefdataParamsSchema = z
  .object({
    resource: z.enum(['modelranges', 'trimlines']).openapi({
      param: {name: 'resource', in: 'path'},
      example: 'modelranges',
    }),
  })
  .openapi('MobileDeRefdataParams');

export type MobileDeRefdataResource = z.infer<typeof mobileDeRefdataParamsSchema>['resource'];
